import { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign } from '@fortawesome/free-solid-svg-icons';
interface PaymentActionProps {
  onManualPayment: (id: number, amount: number) => void;
  id: number;
  amount: number;
}
const PaymentAction: FC<PaymentActionProps> = ({
  onManualPayment,
  id,
  amount
}) => {
  return (
    <div
      onClick={() => onManualPayment(id, amount)}
      style={{
        color: '#16a34a',
        border: '2px solid #16a34a',
        borderRadius: '50%',
        width: '18px',
        height: '18px',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease',
        fontSize: '14px'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.color = '#f0fdf4';
        e.currentTarget.style.borderColor = '#166534';
        e.currentTarget.style.backgroundColor = '#166534';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color = '#16a34a';
        e.currentTarget.style.borderColor = '#16a34a';
        e.currentTarget.style.backgroundColor = 'transparent';
      }}
      title="Pago Manual"
    >
      <FontAwesomeIcon icon={faDollarSign} />
    </div>
  );
};

export default PaymentAction;
